import React from 'react';
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { useDefectTypes } from './hooks/useDefectTypes';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

export const DefectTypeFilter = () => {
  const { filterValues, updateFilter, isShowAll } = useFilters();
  const showAllEnabled = isShowAll('defectType');
  const defectTypes = useDefectTypes(showAllEnabled);
  const {
		customCaptions
	} = JSON.parse(localStorage.getItem("me")) ||
	JSON.parse(sessionStorage.getItem("me"));

  // Clean, declarative initialization
  useFilterInitialization('defectType', defectTypes, {
    waitForData: true,
    getDefaultValue: () => SHOW_ALL_OPTION,
    getParams: (item) => ({ defectTypeId: item.id })
  });

  if (!filterValues.defectType) {
    return null;
  } 

  return (
    <Grid item lg={3} md={6} xs={12}>
      <DyanamicDropdown
        dataSource={defectTypes}
        columns={[{ name: 'name', id: 1 }]}
        showHeader={false}
        width="100%"
        placeholder="Select Defect Type"
        onChange={item => updateFilter('defectType', item, { defectTypeId: item.id })}
        selectdValueToshow="name"
        selectedValue={filterValues.defectType?.value}
        label={`Filter by ${customCaptions?.defectType || 'Defect Type'}`}
        icon={<FilterListIcon style={{ color: 'rgb(48,122,215)' }} />}
        required={false}
        showBorderColor
      />
    </Grid>
  );
}; 
